export default __webpack_public_path__ + "static/media/icon-create-voucher.b3bfc524.svg";